<template>
  <div
    class="app-root"
    :class="{
      small: isSmall,
    }"
  >
    <main>
      <select v-model="focusedAsutus">
        <option value="all">Näita kõik</option>
        <option v-for="name in asutusedDataKeys" :value="name">
          {{ name.replaceAll('<br/>', '') }}
        </option>
      </select>
    </main>
  </div>
</template>

<style scoped>
.app-root {
  --map-width: v-bind(containerWidth + "px");

  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  font-family: GT Eesti, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  line-height: 1;

  -webkit-tap-highlight-color: transparent;
}

main {
  width: 100%;
  flex-grow: 1;
  position: relative;
}

main > select {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 999;

  font-family: GT Eesti, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 1.1em;
  font-weight: 600;

  max-width: 50vw;

  box-sizing: border-box;
  padding: 0.25em;
  border-radius: 4px;

  background-color: rgba(255 255 255 / 0.8);
  border: none;

  cursor: pointer;

  transition: 150ms ease-out;
}

main > select:hover {
  background-color: white;
}

main > select > option {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  color: #f10000;
}
</style>

<script setup>
import {
  ref,
  computed,
  onMounted,
  onUnmounted,
  inject,
  nextTick,
  watch,
} from "vue";

// import * as tallinnGeoData from "./data/tln.json";
import { asutusedData } from "./data/asutused";

const asutusedDataKeys = Object.keys(asutusedData);

//
const containerElement = inject("containerElement");
const containerWidth = ref(0);
const isSmall = computed(() => {
  return containerWidth.value < 550;
});

//
let map;
const group = L.featureGroup();

//
const tmsTileOptions = {
  attribution: `<a href="https://geoportaal.maaamet.ee/est">maa-amet</a>`,
  continuousWorld: true,
  tms: true,
};

const tmshybriid = new L.TileLayer(
  "https://tiles.maaamet.ee/tm/tms/1.0.0/hybriid@GMC/{z}/{x}/{y}.png&ASUTUS=postimees",
  { ...tmsTileOptions, zIndex: 1000 },
);

const tmsfoto = new L.TileLayer(
  "https://tiles.maaamet.ee/tm/tms/1.0.0/foto@GMC/{z}/{x}/{y}.jpg&ASUTUS=postimees",
  { ...tmsTileOptions, zIndex: 0 },
);

/**
 *
 */
function initMap() {
  //
  map = L.map(containerElement.querySelector("main"), {
    onMapReady(map) {
      setTimeout(() => {
        map.invalidateSize(true);
      }, 1000);
    },
    zoomControl: false,
    maxZoom: 16,
    minZoom: 9,
    // zoom: ,
    // center: [],
    layers: [tmshybriid, tmsfoto],
  });

  map.addControl(
    L.control.zoom({
      position: "topleft",
    }),
  );

  map.addControl(L.control.scale({ imperial: false }));

  // ***

  /*const tallinnFeatureOnMap = L.geoJSON(tallinnGeoData, {
    color: "#0064fa",
    weight: 1,
    opacity: 0,
    fillOpacity: 0,
    interactive: false,
  }).addTo(map);*/

  // ***

  const style = {
    color: "#f10000",
    weight: 6,
    opacity: 0.8,
    fillOpacity: 0,
  };

  asutusedDataKeys.forEach((nimi) => {
    const asutus = asutusedData[nimi];
    const featureOnMap = L.geoJSON(asutus.geoJSON, style);
    featureOnMap.bindTooltip(
      `<b>${nimi}</b><br/><small>${asutus.aadress}</small>`,
    );
    featureOnMap.addTo(group);

    featureOnMap.on("click", (e) => {
      focusedAsutus.value = nimi;
    });

    asutus.featureOnMap = featureOnMap;
  });

  group.addTo(map);

  map.fitBounds(group.getBounds());

  // ***

  // open attribution links in new tab
  const links = containerElement.querySelectorAll("a");
  links.forEach((a) => {
    if (a.href.startsWith("http") && !a.href.includes("#")) {
      // console.log(a);
      a.setAttribute("target", "_blank");
    }
  });
}

//
const focusedAsutus = ref("all");

watch(focusedAsutus, () => {
  console.log(">", focusedAsutus.value);
  nextTick(() => {
    if (focusedAsutus.value === "all") {
      map.fitBounds(group.getBounds());
    } else {
      const { featureOnMap } = asutusedData[focusedAsutus.value];
      map.fitBounds(featureOnMap.getBounds(), { animate: true });
      setTimeout(() => {
        featureOnMap.openTooltip();
      }, 300);
    }
  });
});

/**
 *
 */
function onResize() {
  containerWidth.value = containerElement.clientWidth;

  map.invalidateSize();
}

// ***

onMounted(() => {
  initMap();

  window.addEventListener("resize", onResize);
  onResize();
  window.setTimeout(onResize, 1500);
});

onUnmounted(() => {
  window.removeEventListener("resize", onResize);
});
</script>
